module.exports = __webpack_public_path__ + "img/JOC_3739.75e2574d.jpg";